import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Chip
} from '@mui/material';
import {
  Check as CheckIcon,
  Close as CloseIcon,
  ArrowUpward as UpgradeIcon,
  ArrowDownward as DowngradeIcon,
  Remove as NoChangeIcon
} from '@mui/icons-material';

function TierComparisonTable({ currentTier, newTier }) {
  if (!currentTier || !newTier) return null;

  const formatPrice = (price) => `€${(price / 100).toFixed(2)}`;
  const formatNumber = (num) => num.toLocaleString();

  const getChangeIndicator = (current, next) => {
    if (next > current) {
      return <UpgradeIcon color="success" fontSize="small" />;
    } else if (next < current) {
      return <DowngradeIcon color="error" fontSize="small" />;
    }
    return <NoChangeIcon color="disabled" fontSize="small" />;
  };

  const getChangeColor = (current, next) => {
    if (next > current) return 'success.main';
    if (next < current) return 'error.main';
    return 'text.primary';
  };

  const features = [
    {
      name: 'Monthly API Calls',
      current: formatNumber(currentTier.limits.monthlyLimit),
      new: formatNumber(newTier.limits.monthlyLimit),
      compare: (a, b) => b.limits.monthlyLimit - a.limits.monthlyLimit
    },
    {
      name: 'API Keys',
      current: formatNumber(currentTier.limits.apiKeyLimit),
      new: formatNumber(newTier.limits.apiKeyLimit),
      compare: (a, b) => b.limits.apiKeyLimit - a.limits.apiKeyLimit
    },
    {
      name: 'Base Price',
      current: formatPrice(currentTier.pricing.basePrice),
      new: formatPrice(newTier.pricing.basePrice),
      compare: (a, b) => b.pricing.basePrice - a.pricing.basePrice
    } 
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom>
        Feature Comparison
      </Typography>
      
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: 'background.default' }}>
              <TableCell>Feature</TableCell>
              <TableCell align="right">
                Current Tier
                <Chip 
                  label={currentTier.name}
                  size="small"
                  sx={{ ml: 1 }}
                />
              </TableCell>
              <TableCell align="center" sx={{ width: 50 }}>
                Change
              </TableCell>
              <TableCell align="right">
                New Tier
                <Chip 
                  label={newTier.name}
                  size="small"
                  sx={{ ml: 1 }}
                />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {features.map((feature) => (
              <TableRow key={feature.name}>
                <TableCell component="th" scope="row">
                  {feature.name}
                </TableCell>
                <TableCell align="right">
                  {feature.current}
                </TableCell>
                <TableCell align="center">
                  {getChangeIndicator(
                    feature.compare(currentTier, currentTier),
                    feature.compare(currentTier, newTier)
                  )}
                </TableCell>
                <TableCell 
                  align="right"
                  sx={{ 
                    color: getChangeColor(
                      feature.compare(currentTier, currentTier),
                      feature.compare(currentTier, newTier)
                    ),
                    fontWeight: 'medium'
                  }}
                >
                  {feature.new}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default TierComparisonTable; 